import { createApi } from '@redux/createApi';

const tags = {
  getRoles: 'getRoles',
  getEndpointRoles: 'getEndpointRoles',
  createRole: 'createRole',
  updateRole: 'updateRole',
  setUserRole:'setUserRole',
};

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  tagTypes: [tags.getRoles],
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/role/list`,
        });
      },
      providesTags: [tags.getRoles],
      serializeQueryArgs: ({ queryArgs }) => {
        const newQueryArgs = { ...queryArgs };
        if (newQueryArgs.page) {
          delete newQueryArgs.page;
        }
        return newQueryArgs;
      },
      transformResponse: (data) => {
        const permissionsMap = data.reduce((acc, role) => {
          role.permissions.forEach(permission => {
            if (!acc[permission]) {
              acc[permission] = [];
            }
            acc[permission].push(role.name);
          });
          return acc;
        }, {});

        const permissionsArray = Object.entries(permissionsMap).map(([permission, roles]) => ({
          name: permission,
          roles: roles
        }));

        return {
          permissions: permissionsArray,
          roles: data.map(v => v.name),
        }
      }
    }),
    getEndpointRoles: builder.query({
      query: () => {
        return ({
          method: 'get', url: `/role/endpoint/list`,
        });
      },
      providesTags: [tags.getEndpointRoles],
      serializeQueryArgs: ({ queryArgs }) => {
        const newQueryArgs = { ...queryArgs };
        if (newQueryArgs.page) {
          delete newQueryArgs.page;
        }
        return newQueryArgs;
      },
      transformResponse: (data) => {
       return data
      }
    }),
    createRole: builder.mutation({
      query: ({ role, permissions }) => {
        return ({
          method: 'post', url: `/role/create`,
          body: { name: role, permissions },
        });
      },
      providesTags: [tags.createRole],
      invalidatesTags: [tags.getRoles],
    }),
    updateRole: builder.mutation({
      query: ({ role, permissions }) => {
        return ({
          method: 'post', url: `/role/update`,
          body: { name: role, permissions },
        });
      },
      providesTags: [tags.updateRole],
      invalidatesTags: [tags.getRoles],
    }),
    setUserRole: builder.mutation({
      query: ({ role, pk }) => {
        return ({
          method: 'post', url: `/role/set-user-role`,
          body: { role, pk },
        });
      },
      providesTags: [tags.setUserRole],
      invalidatesTags: [tags.getRoles],
    }),
  }),
});


export const {
  useGetRolesQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useGetEndpointRolesQuery,
} = rolesApi;

